const BREAKPOINT_XLS = 1100;
const desktopXlsMql = window.matchMedia(`(min-width: ${BREAKPOINT_XLS}px)`);

(function () {
  // Last known pointer position, used to tell whether the pointer is still on
  // its way from a menu item down to the mega menu panel.
  let lastPointer = null;
  document.addEventListener(
    "mousemove",
    (e) => {
      lastPointer = { x: e.clientX, y: e.clientY };
    },
    { passive: true }
  );

  const animateMegaMenu = (header) => {
    const menu = header.querySelector(".list-menu--inline");
    const menuLinks = header.querySelectorAll(".list-menu-item");
    const megaMenus = header.querySelectorAll(".mega-menu");
    const mobileMegaMenus = header.querySelectorAll(".mobile-mega-menu");

    if (
      !megaMenus ||
      !menuLinks ||
      menuLinks.length === 0 ||
      megaMenus.length === 0
    ) {
      return;
    }

    const closeMenuDisclosure = () => {
      const disclosures = header.querySelectorAll("details-disclosure");
      if (customElements.get("details-disclosure")) {
        disclosures.forEach((disclosure) => {
          disclosure.close();
        });
      }

      const disclosureLists = header.querySelectorAll(".disclosure__list");
      disclosureLists.forEach((disclosureList) => {
        disclosureList.setAttribute("hidden", true);
      });
    };

    const animateSubmenuLinks = (megaMenu) => {
      if (!megaMenu) return;
      const submenu = megaMenu.querySelector(".mega-menu__submenu");
      const mediaBlocks = megaMenu.querySelectorAll(".mega-menu__media");
      if (!submenu) return;
      const sublinks = submenu.querySelectorAll(".mega-menu__submenu-link");

      const removeActiveClass = () => {
        sublinks.forEach((sublink) => {
          sublink.classList.remove("mega-menu__submenu-link--active");
        });

        mediaBlocks.forEach((block) => {
          block.classList.remove("mega-menu__media--active");
          block.removeAttribute("style");
        });
      };

      const resetActiveClass = () => {
        removeActiveClass();
        sublinks[0]?.classList.add("mega-menu__submenu-link--active");
        if (mediaBlocks[0]) {
          mediaBlocks[0].classList.add("mega-menu__media--active");
          mediaBlocks[0].style.display = "flex";
        }
      };

      const toggleActive = (sublink) => {
        if (sublink.classList.contains("mega-menu__submenu-link--active")) {
          return;
        }
        removeActiveClass();
        sublink.classList.add("mega-menu__submenu-link--active");
        const tabId = sublink.getAttribute("data-mega-menu-tab-id");
        const needMedia = megaMenu.querySelector(
          `.mega-menu__media[data-mega-menu-tab-id='${tabId}']`
        );
        if (!needMedia) return;
        needMedia.style.display = "flex";
        setTimeout(() => {
          needMedia.classList.add("mega-menu__media--active");
        }, 150);
      };

      sublinks.forEach((sublink) => {
        sublink.addEventListener("mouseenter", (e) => {
          toggleActive(sublink);
        });
      });

      megaMenu.addEventListener("mouseleave", resetActiveClass);
    };

    const desktopMegaMenuMql = desktopXlsMql;

    const hasOpenDesktopMegaMenu = () =>
      Array.from(megaMenus).some(
        (menu) =>
          menu.hasAttribute("open") &&
          !menu.classList.contains("mobile-mega-menu")
      );

    const unlockBodyScrollIfNoDesktopMegaMenuOpen = () => {
      if (!hasOpenDesktopMegaMenu()) {
        document.body.classList.remove("overflow-hidden");
      }
    };

    const getFixedContainingBlock = (el) => {
      let node = el?.parentElement;
      while (node && node !== document.documentElement) {
        const style = getComputedStyle(node);
        const willChange = style.willChange || "";
        if (
          style.transform !== "none" ||
          style.perspective !== "none" ||
          (style.filter && style.filter !== "none") ||
          willChange.includes("transform") ||
          willChange.includes("perspective") ||
          willChange.includes("filter")
        ) {
          return node;
        }
        node = node.parentElement;
      }
      return null;
    };

    const updateMegaMenuTop = (megaMenu) => {
      const headerWrapper = header.querySelector(".header-wrapper");
      if (!headerWrapper) return;
      const reference = megaMenu || currentDesktopMegaMenu;
      if (!reference) return;
      const headerBottom = headerWrapper.getBoundingClientRect().bottom;
      const containingBlock = getFixedContainingBlock(reference);
      const offset = containingBlock
        ? headerBottom - containingBlock.getBoundingClientRect().top
        : headerBottom;
      document.documentElement.style.setProperty(
        "--mega-menu-top",
        `${offset}px`
      );
    };

    const clearMegaMenuTop = () => {
      document.documentElement.style.removeProperty("--mega-menu-top");
    };

    let currentDesktopMegaMenu = null;
    let megaMenuResizeHandler = null;

    const bindMegaMenuResize = () => {
      if (megaMenuResizeHandler) return;
      megaMenuResizeHandler = () => updateMegaMenuTop();
      window.addEventListener("resize", megaMenuResizeHandler);
    };

    const unbindMegaMenuResize = () => {
      if (!megaMenuResizeHandler) return;
      window.removeEventListener("resize", megaMenuResizeHandler);
      megaMenuResizeHandler = null;
    };

    const setDisplayStyles = (megaMenu) => {
      megaMenu.setAttribute("open", "true");
      header.classList.add("header-sticky-with-opened-mega-menu");

      if (
        desktopMegaMenuMql.matches &&
        !megaMenu.classList.contains("mobile-mega-menu")
      ) {
        document.body.classList.add("overflow-hidden");
        currentDesktopMegaMenu = megaMenu;
        updateMegaMenuTop(megaMenu);
        bindMegaMenuResize();
      }

      closeMenuDisclosure();
      animateSubmenuLinks(megaMenu);
    };

    const setHiddenStyles = (megaMenu) => {
      megaMenu.removeAttribute("open");
      header.classList.remove("header-sticky-with-opened-mega-menu");

      if (!megaMenu.classList.contains("mobile-mega-menu")) {
        if (megaMenu === currentDesktopMegaMenu) {
          currentDesktopMegaMenu = null;
        }
        unbindMegaMenuResize();
        if (!hasOpenDesktopMegaMenu()) {
          clearMegaMenuTop();
        }
      }

      unlockBodyScrollIfNoDesktopMegaMenuOpen();
    };

    const checkMenuPosition = (megaMenu) => {
      const modalWindow = megaMenu?.querySelector(".mega-menu__wrapper");
      if (!menu || !modalWindow) return;
      const mainMenuRect = menu.getBoundingClientRect();
      const megaMenuRect = modalWindow.getBoundingClientRect();
      if (mainMenuRect.right > megaMenuRect.right) {
        const difWidth = 8 + mainMenuRect.right - megaMenuRect.right;
        modalWindow.style.width = `calc(${difWidth}px + 1vw * 100 * 820 / 1440)`;
      }
    };

    const checkScrollContainers = (megaMenu) => {
      const productBlocks = megaMenu.querySelectorAll(".mega-menu__products");
      const menuBlocks = megaMenu.querySelectorAll(".mega-menu__menu");
      const cardsBlocks = megaMenu.querySelectorAll(
        ".mega-menu__cards-wrapper"
      );

      if (productBlocks && productBlocks.length > 0) {
        productBlocks.forEach((block) => {
          if (block.scrollHeight > block.clientHeight) {
            block.classList.add("mega-menu__products--scroll");
          } else {
            block.classList.remove("mega-menu__products--scroll");
          }
        });
      }

      if (menuBlocks || menuBlocks.length > 0) {
        menuBlocks.forEach((block) => {
          if (block.scrollHeight > block.clientHeight) {
            block.classList.add("mega-menu__menu--scroll");
          } else {
            block.classList.remove("mega-menu__menu--scroll");
          }
        });
      }

      if (cardsBlocks || cardsBlocks.length > 0) {
        cardsBlocks.forEach((block) => {
          if (block.scrollHeight > block.clientHeight) {
            block.classList.add("mega-menu__cards-wrapper--scroll");
          } else {
            block.classList.remove("mega-menu__cards-wrapper--scroll");
          }
        });
      }
    };

    // Closing is deferred so the pointer can cross the gap between a menu item
    // and its fixed-position mega menu panel without the panel disappearing.
    // While the pointer is still in that gap, the close keeps being postponed,
    // however slowly it moves.
    const MEGA_MENU_CLOSE_DELAY = 250;
    const MEGA_MENU_BRIDGE_SLACK = 12;
    let pendingClose = null;

    const isPointerInBridge = (link) => {
      const trigger = link?.querySelector(":scope > .header__menu-item");
      const megaMenu = link?.querySelector(":scope > .mega-menu");
      if (!lastPointer || !trigger || megaMenu?.getAttribute("open") !== "true")
        return false;

      const { x, y } = lastPointer;
      const triggerRect = trigger.getBoundingClientRect();
      const panelTop = megaMenu.getBoundingClientRect().top;
      return (
        x >= triggerRect.left - MEGA_MENU_BRIDGE_SLACK &&
        x <= triggerRect.right + MEGA_MENU_BRIDGE_SLACK &&
        y >= triggerRect.bottom - 1 &&
        y <= panelTop + 1
      );
    };

    const cancelPendingClose = () => {
      if (!pendingClose) return;
      clearTimeout(pendingClose.timer);
      pendingClose = null;
    };

    const flushPendingClose = () => {
      if (!pendingClose) return;
      const { close } = pendingClose;
      cancelPendingClose();
      close();
    };

    const scheduleClose = (link, close) => {
      cancelPendingClose();
      pendingClose = {
        link,
        close,
        timer: setTimeout(() => {
          if (isPointerInBridge(link)) {
            scheduleClose(link, close);
          } else {
            flushPendingClose();
          }
        }, MEGA_MENU_CLOSE_DELAY),
      };
    };

    const openMegaMenu = (link) => {
      if (link.classList.contains("list-menu--megamenu")) {
        link.classList.add("list-menu--megamenu-visible");

        megaMenus.forEach((megaMenu) => {
          if (megaMenu == link.querySelector(".mega-menu")) {
            checkMenuPosition(megaMenu);
            checkScrollContainers(megaMenu);
            setDisplayStyles(megaMenu);

            const overlay = megaMenu.querySelector(".mega-menu__overlay");
            const handleMouseLeaveWrapper = () => {
              cancelPendingClose();
              setHiddenStyles(megaMenu);
              link.classList.remove("list-menu--megamenu-visible");
              overlay?.removeEventListener(
                "mouseenter",
                handleMouseLeaveWrapper
              );
            };
            overlay?.addEventListener("mouseenter", handleMouseLeaveWrapper);
          }
        });

        menuLinks.forEach((el) => {
          if (el !== link) {
            el.classList.remove("list-menu--megamenu-visible");
          }
        });
      } else {
        menuLinks.forEach((el) => {
          el.classList.remove("list-menu--megamenu-visible");
        });
      }
    };

    menuLinks.forEach((link) => {
      link.addEventListener("mouseenter", (e) => {
        // Re-entering the same item (or its panel) keeps it open; moving to a
        // different item closes the previous panel straight away.
        if (pendingClose?.link === link) {
          cancelPendingClose();
        } else {
          flushPendingClose();
        }

        if (link.classList.contains("list-menu--megamenu")) {
          openMegaMenu(link);
        } else {
          menuLinks.forEach((el) => {
            el.classList.remove("list-menu--megamenu-visible");
          });
        }
      });

      link.addEventListener("mouseleave", (e) => {
        if (link.classList.contains("list-menu--megamenu")) {
          const megaMenu = link.querySelector(".mega-menu");
          if (megaMenu) scheduleClose(link, () => setHiddenStyles(megaMenu));
        }
      });
    });

    const hiddenAllMegaMenu = () => {
      menuLinks.forEach((link) => {
        link.classList.remove("list-menu--megamenu-visible");
      });

      megaMenus.forEach((megaMenu) => {
        setHiddenStyles(megaMenu);
      });
    };

    menu.addEventListener("mouseleave", () => {
      scheduleClose(pendingClose?.link ?? null, hiddenAllMegaMenu);
    });

    // rename color swatch inputs ids and labels for desktop mega menu
    megaMenus.forEach((megaMenu, index) => {
      const allMediaBlocks = megaMenu.querySelectorAll(".mega-menu__media");

      if (!allMediaBlocks || allMediaBlocks.length === 0) return;

      allMediaBlocks.forEach((block) => {
        const tabId = block.getAttribute("data-mega-menu-tab-id");

        block
          .querySelectorAll(".mega-menu__products-card")
          .forEach((productCard) => {
            const allSwatchInputs = productCard.querySelectorAll(
              "input[type='radio']"
            );
            const allSwatchLabels =
              productCard.querySelectorAll("label.color-swatch");

            allSwatchInputs.forEach((input) => {
              const oldId = input.id;
              const oldName = input.name;
              input.id = `${oldId}-mega${index}-tab${tabId}`;
              input.name = `${oldName}-mega${index}-tab${tabId}`;
            });
            allSwatchLabels.forEach((label) => {
              const oldFor = label.htmlFor;
              label.htmlFor = `${oldFor}-mega${index}-tab${tabId}`;
            });
          });
      });
    });

    // rename color swatch inputs ids and labels for mobile mega menu
    mobileMegaMenus.forEach((megaMenu, menuId) => {
      const allMobileItems = megaMenu.querySelectorAll(
        ".mobile-mega-menu__item"
      );

      if (!allMobileItems || allMobileItems.length === 0) return;

      allMobileItems.forEach((item, itemId) => {
        item
          .querySelectorAll(".mobile-mega-menu__products-card")
          .forEach((productCard) => {
            const allSwatchInputs = productCard.querySelectorAll(
              "input[type='radio']"
            );
            const allSwatchLabels =
              productCard.querySelectorAll("label.color-swatch");

            allSwatchInputs.forEach((input) => {
              const oldId = input.id;
              const oldName = input.name;
              input.id = `${oldId}-mob-mega${menuId}-item${itemId}`;
              input.name = `${oldName}-mob-mega${menuId}-tab${itemId}`;
            });
            allSwatchLabels.forEach((label) => {
              const oldFor = label.htmlFor;
              label.htmlFor = `${oldFor}-mob-mega${menuId}-item${itemId}`;
            });
          });
      });
    });
  };

  const closeMobileMenu = (header) => {
    const menuCloseBtn = header.querySelector(".header__modal-close-button");
    const mobileMenuDrawer = header.querySelector("header-drawer");
    menuCloseBtn.addEventListener("click", (e) => {
      mobileMenuDrawer.closeMenuDrawer(e);
    });
  };

  const onHoverRemoveOverlay = (event) => {
    if (
      !desktopXlsMql.matches ||
      !event.target?.closest(".shopify-section-header") ||
      event.target.closest(".shopify-section-header-sticky") ||
      event.target.closest(".header-sticky-with-opened-mega-menu")
    ) {
      return;
    }
    const header = event.target.closest(".shopify-section-header");
    header.classList.remove("color-background-overlay");
    header.classList.add("color-background-overlay-hidden");

    header.removeEventListener("mousemove", onMouseMove);
  };

  const onHoverAddOverlay = (event) => {
    if (
      !desktopXlsMql.matches ||
      !event.target?.classList.contains("shopify-section-header") ||
      event.target.classList.contains("shopify-section-header-sticky") ||
      event.target.classList.contains("header-sticky-with-opened-mega-menu")
    ) {
      return;
    }
    const searchModal = document.querySelector("header-search.header__search");
    const burgerMenu = document.querySelector("burger-menu");
    if (
      (searchModal && searchModal.hasAttribute("open")) ||
      (burgerMenu && burgerMenu.hasAttribute("opened"))
    ) {
      return;
    }
    event.target.classList.add("color-background-overlay");
    event.target.classList.remove("color-background-overlay-hidden");
  };

  const initHeaderOverlay = (header) => {
    const main = document.getElementById("MainContent");
    const sections = main.querySelectorAll(".shopify-section");

    if (sections.length > 0) {
      const sectionFirstChild = sections[0].querySelector(
        "[data-header-overlay='true']"
      );
      // selector with custom-liquid ".shopify-section-group-header-group, .shopify-section-group-overlay-group.custom-liquid-section"
      const headerGroupSections = document.querySelectorAll(
        ".shopify-section-group-header-group"
      );
      const breadcrumbs = document.querySelector(".breadcrumb");

      const removeColorScheme = (element) => {
        let classNames = element.getAttribute("class");
        classNames = classNames.replace(/color-background-\d+/g, "");
        element.setAttribute("class", classNames);
      };

      if (sectionFirstChild) {
        if (headerGroupSections[headerGroupSections.length - 1] === header) {
          sections[0].classList.add("section--has-overlay");
          sections[0].classList.remove("not-margin");
          header.classList.add("color-background-overlay");
          if (breadcrumbs) {
            removeColorScheme(breadcrumbs);
            const colorScheme =
              sectionFirstChild.getAttribute("data-color-scheme");
            if (colorScheme) breadcrumbs.classList.add(`color-${colorScheme}`);
          }
        } else {
          sections[0].classList.add("not-margin");
          header.classList.remove("color-background-overlay");
          header.removeEventListener("mouseenter", onHoverRemoveOverlay);
          header.removeEventListener("mouseleave", onHoverAddOverlay);
          if (breadcrumbs) removeColorScheme(breadcrumbs);
        }
      } else {
        header.classList.remove("color-background-overlay");
        header.removeEventListener("mouseenter", onHoverRemoveOverlay);
        header.removeEventListener("mouseleave", onHoverAddOverlay);
        if (breadcrumbs) removeColorScheme(breadcrumbs);
      }
    }
  };

  const onMouseMove = (event) => {
    onHoverRemoveOverlay(event);
  };

  const addListenersOnHeaderOverlay = (header) => {
    if (header && header.classList.contains("color-background-overlay")) {
      header.addEventListener("mouseenter", onHoverRemoveOverlay);
      header.addEventListener("mouseleave", onHoverAddOverlay);

      // get cursor position when page loading
      header.addEventListener("mousemove", onMouseMove);
    }
  };

  const initMegaSubmenu = (header) => {
    const megaSubmenuLinks = header.querySelectorAll(".list-menu--megasubmenu");
    if (!megaSubmenuLinks || !megaSubmenuLinks.length) return;

    megaSubmenuLinks.forEach((link) => {
      const tabs = link.querySelectorAll(".mega-submenu__tab");
      const submenus = link.querySelectorAll(".mega-submenu__submenu");

      const onToggle = (event) => {
        const tab = event.target;
        if (!tab || !tab.classList.contains("mega-submenu__tab")) return;
        const tabId = tab.dataset.tabId;
        tabs.forEach((tab) => {
          tab.classList.remove("active");
        });
        tab.classList.add("active");
        submenus.forEach((submenu) => {
          submenu.classList.remove("active");
          if (submenu.dataset.tabId === tabId) {
            submenu.classList.add("active");
          }
        });
      };

      tabs.forEach((tab) => {
        tab.addEventListener("click", onToggle);
        tab.addEventListener("mouseenter", onToggle);
      });

      // The panel is fixed to the bottom of the header, which can sit well
      // below the menu item (tall logo, extra header padding). Size an
      // invisible bridge on the panel to span that gap under the item, so the
      // pointer keeps the panel hovered on its way down.
      const trigger = link.querySelector(":scope > .header__menu-item");
      const panel = link.querySelector(":scope > .mega-submenu");
      if (!trigger || !panel) return;

      link.addEventListener("mouseenter", () => {
        // Measure without the closed-state transform so we get the final spot.
        const transform = panel.style.transform;
        panel.style.transform = "none";
        const panelRect = panel.getBoundingClientRect();
        panel.style.transform = transform;

        const triggerRect = trigger.getBoundingClientRect();
        const gap = Math.max(panelRect.top - triggerRect.bottom, 0);
        panel.style.setProperty("--mega-submenu-bridge-height", `${gap}px`);
        panel.style.setProperty(
          "--mega-submenu-bridge-left",
          `${triggerRect.left - panelRect.left}px`
        );
        panel.style.setProperty(
          "--mega-submenu-bridge-width",
          `${triggerRect.width}px`
        );
      });
    });
  };

  // Standard (content-width) dropdown menus rendered by the `dropdown_menu`
  // header block. The panel is fixed so it can escape the inline menu's
  // `overflow: hidden`; here we centre it under its trigger, keep it inside the
  // viewport and decide which side nested submenus should fly out to.
  const initDropdownMenus = (header) => {
    const dropdownItems = header.querySelectorAll(".list-menu--dropdown");
    if (!dropdownItems.length) return;

    const VIEWPORT_PADDING = 12;

    // A fixed element is positioned relative to the nearest ancestor that
    // establishes a containing block (transform/filter/will-change). The header
    // sets `will-change: transform`, so we offset our coordinates against it.
    const getFixedContainingBlock = (el) => {
      let node = el?.parentElement;
      while (node && node !== document.documentElement) {
        const style = getComputedStyle(node);
        const willChange = style.willChange || "";
        if (
          style.transform !== "none" ||
          style.perspective !== "none" ||
          (style.filter && style.filter !== "none") ||
          willChange.includes("transform") ||
          willChange.includes("perspective") ||
          willChange.includes("filter")
        ) {
          return node;
        }
        node = node.parentElement;
      }
      return null;
    };

    const positionPanel = (item) => {
      const panel = item.querySelector(":scope > .dropdown-menu");
      const trigger = item.querySelector(":scope > .header__menu-item");
      const nav = item.closest(".header__inline-menu");
      if (!panel || !trigger || !nav) return;

      const containingBlock = getFixedContainingBlock(panel);
      const cbRect = containingBlock
        ? containingBlock.getBoundingClientRect()
        : { left: 0, top: 0 };

      const triggerRect = trigger.getBoundingClientRect();
      const navRect = nav.getBoundingClientRect();
      const panelWidth = panel.offsetWidth;
      const panelHeight = panel.offsetHeight;
      const vw = document.documentElement.clientWidth;
      const vh = document.documentElement.clientHeight;

      // Horizontal: centre under the trigger, then clamp inside the viewport.
      const triggerCenter = triggerRect.left + triggerRect.width / 2;
      let left = triggerCenter - panelWidth / 2;
      left = Math.max(
        VIEWPORT_PADDING,
        Math.min(left, vw - VIEWPORT_PADDING - panelWidth)
      );

      // Vertical: sit just below the menu row, shift up on overflow.
      let top = navRect.bottom;
      if (top + panelHeight > vh - VIEWPORT_PADDING) {
        top = Math.max(VIEWPORT_PADDING, vh - VIEWPORT_PADDING - panelHeight);
      }

      panel.style.left = `${left - cbRect.left}px`;
      panel.style.top = `${top - cbRect.top}px`;
    };

    const positionSubmenu = (subItem) => {
      const submenu = subItem.querySelector(
        ":scope > .dropdown-menu__submenu"
      );
      if (!submenu) return;

      // Reset before measuring.
      submenu.classList.remove("dropdown-menu__submenu--left");
      submenu.style.setProperty("--submenu-shift-y", "0px");

      const inner =
        submenu.querySelector(":scope > .dropdown-menu__submenu-inner") ||
        submenu;
      const vw = document.documentElement.clientWidth;
      const vh = document.documentElement.clientHeight;
      const rect = inner.getBoundingClientRect();

      // Flip to the left when there is no room on the right (and room on left).
      if (rect.right > vw - VIEWPORT_PADDING) {
        const parentRect = subItem.getBoundingClientRect();
        if (parentRect.left - rect.width - VIEWPORT_PADDING >= 0) {
          submenu.classList.add("dropdown-menu__submenu--left");
        }
      }

      // Nudge up when the submenu would overflow the bottom of the viewport.
      const afterRect = inner.getBoundingClientRect();
      if (afterRect.bottom > vh - VIEWPORT_PADDING) {
        const shift = Math.min(
          afterRect.top - VIEWPORT_PADDING,
          afterRect.bottom - (vh - VIEWPORT_PADDING)
        );
        if (shift > 0) {
          submenu.style.setProperty("--submenu-shift-y", `-${shift}px`);
        }
      }
    };

    dropdownItems.forEach((item) => {
      item.addEventListener("mouseenter", () => positionPanel(item));
      item.addEventListener("focusin", () => positionPanel(item));

      item
        .querySelectorAll(".dropdown-menu__item--has-children")
        .forEach((subItem) => {
          subItem.addEventListener("mouseenter", () =>
            positionSubmenu(subItem)
          );
          subItem.addEventListener("focusin", () => positionSubmenu(subItem));
        });
    });

    // Reposition any open dropdown on resize so it stays within the viewport.
    if (!window.__dropdownMenuResizeBound) {
      window.__dropdownMenuResizeBound = true;
      window.addEventListener("resize", () => {
        document.querySelectorAll(".list-menu--dropdown").forEach((item) => {
          if (item.matches(":hover")) positionPanel(item);
          item
            .querySelectorAll(".dropdown-menu__item--has-children")
            .forEach((subItem) => {
              if (subItem.matches(":hover")) positionSubmenu(subItem);
            });
        });
      });
    }
  };

  const popupModalInTopBar = () => {
    const openButtons = document.querySelectorAll(
      ".popup-modal--top-bar__close"
    );
    const disclosures = document.querySelectorAll(
      ".popup-modal--top-bar .localization-selector , .disclosure"
    );

    const invisibleLayouts = document.querySelectorAll(".invisible-layout");

    // Logic for show modal
    openButtons.forEach((btn) => {
      btn.addEventListener("click", () => {
        disclosures.forEach((e) => {
          e.setAttribute("aria-expanded", "false");
        });
        document.body.classList.toggle(
          "localization-modal-open",
          Boolean(
            document.querySelector(
              ".popup-modal--top-bar button[aria-expanded='true']"
            )
          )
        );
      });
    });

    // Logic for trapFocus modal
    disclosures.forEach((button) => {
      button.addEventListener("keydown", (e) => {
        if (e.key === "Enter" || e.key === " ") {
          const modalContext = e.target.nextElementSibling;
          trapFocus(modalContext);
        }
      });
    });

    // Logic for body overflow hidden
    const disclosures2 = document.querySelectorAll(".disclosure__button");

    disclosures2.forEach((button) => {
      const observer = new MutationObserver(() => {
        const isModalOpened =
          event.target.parentElement.getAttribute("aria-expanded") === "true";
        if (isModalOpened) {
          document.body.classList.add("overflow-hidden-mobile");
        } else {
          document.body.classList.remove("overflow-hidden-mobile");
        }
      });

      observer.observe(button, {
        attributes: true,
        attributeFilter: ["aria-expanded"],
      });
    });
  };

  const initHeader = () => {
    const header = document.querySelector(".shopify-section-header");
    if (!header) return;

    animateMegaMenu(header);
    closeMobileMenu(header);
    popupModalInTopBar();
    initHeaderOverlay(header);
    addListenersOnHeaderOverlay(header);
    initMegaSubmenu(header);
    initDropdownMenus(header);
  };

  initHeader();

  document.addEventListener("shopify:section:load", initHeader);
  document.addEventListener("shopify:section:unload", initHeader);
  document.addEventListener("shopify:section:reorder", initHeader);
})();

class BurgerMenu extends HTMLElement {
  constructor() {
    super();
    this.header = document.querySelector(".header-wrapper");
    this.headerLogo = this.header.querySelector(".header__heading-link");
    this.burgerMenu = this.querySelector(".burger-menu");
    this.toggleBtn = this.querySelector(".burger-menu__toggle");
    this.isOpen = false;

    if (this.header) this.header.preventHide = false;

    this.setListeners();
  }

  open() {
    if (this.header) this.header.preventHide = true;
    this.setAttribute("opened", "true");
    document.body.classList.add("overflow-hidden-drawer");
    this.burgerMenu?.addEventListener("transitionend", () => trapFocus(this), {
      once: true,
    });
    this.isOpen = true;
  }

  close() {
    document.body.classList.remove("overflow-hidden-drawer");
    this.removeAttribute("opened");
    if (this.header) this.header.preventHide = false;
    this.isOpen = false;
  }

  setListeners() {
    this.toggleBtn?.addEventListener("click", () => {
      if (this.isOpen) {
        this.close();
      } else {
        this.open();
      }
    });
    this.burgerMenu?.addEventListener("keyup", (event) => {
      event.code === "Escape" && this.close();
    });

    const resizeObserver = new ResizeObserver(() => {
      if (!desktopXlsMql.matches) {
        this.close();
      }
    });

    resizeObserver.observe(this);
  }
}

if (!customElements.get("burger-menu")) {
  customElements.define("burger-menu", BurgerMenu);
}

class HeaderSearch extends HTMLElement {
  constructor() {
    super();
    this.header = document.querySelector(".header-wrapper");
    this.searchLinks = this.querySelectorAll(".header__icon--search");
    this.closeButton = this.querySelector(".header__search-close");
    this.overlayEl = this.querySelector(".header__search-overlay");
    this.modalContainer = this.querySelector(".header__search-inner");
    this.resetButton = document.querySelector(".search__button--reset");
    this.resetButtons = document.querySelectorAll(".search__button--reset");
    this.searchInput = this.querySelector(".header__search-inner .search__input");

    this.open = this.onOpen.bind(this);
    this.close = this.onClose.bind(this);
    this.handleKeyDown = this.onHandleKeyDown.bind(this);

    this.searchLinks.forEach((link) =>
      link.addEventListener("click", this.open)
    );
    this.closeButton?.addEventListener("click", this.close);
    this.overlayEl?.addEventListener("click", this.close);
    this.header?.addEventListener("keydown", this.handleKeyDown);

    this.searchInput?.addEventListener(
      "input",
      this.observePredictiveSearch.bind(this)
    );
  }

  observePredictiveSearch() {
    const container = document.querySelectorAll("predictive-search");
    if (!container) return;

    const observer = new MutationObserver(() => {
      const emptyWrapper = document.querySelector(
        ".predictive-search__empty--wrapper"
      );
      this.resetButtons.forEach((btn) => {
        if (emptyWrapper) {
          btn.setAttribute("style", "display: none;");
        } else {
          btn.removeAttribute("style");
        }
      });
    });

    container.forEach((containerItem) => {
      observer.observe(containerItem, {
        childList: true,
        subtree: true,
      });
    });
  }

  onOpen(event) {
    event.preventDefault();
    if (this.header) this.header.preventHide = true;
    this.setAttribute("open", true);

    if (
      this.modalContainer &&
      getComputedStyle(this.modalContainer).visibility === "hidden"
    ) {
      this.modalContainer.style.setProperty("visibility", "visible");
      this.modalContainer.style.setProperty("pointer-events", "all");
    }

    trapFocus(this.modalContainer, this.searchInput);
    document.body.classList.add("overflow-hidden");
  }

  onClose() {
    this.removeAttribute("open");
    if (this.header) this.header.preventHide = false;

    this.modalContainer?.style.removeProperty("visibility");
    this.modalContainer?.style.removeProperty("pointer-events");

    document.body.classList.remove("overflow-hidden");

    this.modalContainer.addEventListener("transitionend", () => {
      removeTrapFocus();
      if (this.searchLink) this.searchLink.focus();
    });
  }

  onHandleKeyDown(event) {
    if (this.getAttribute("open")) {
      if (event.key === "Escape") {
        this.close();
      }
    }
  }

  disconnectedCallback() {
    this.header.removeEventListener("keydown", this.handleKeyDown);
  }
}

if (!customElements.get("header-search")) {
  customElements.define("header-search", HeaderSearch);
}
